import Entity from './entity'
export default class outair_data extends Entity<number>{
}